import {AfterViewInit, Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-about-page',
    imports: [
        NgClass
    ],
  templateUrl: './about-page.component.html',
  styleUrl: './about-page.component.scss'
})
export class AboutPageComponent implements AfterViewInit{
    @ViewChild('title') titleElement!: ElementRef;
    isHighlighted: boolean = false;

    ngAfterViewInit() {
        this.checkTitlePosition();
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.checkTitlePosition();
    }

    checkTitlePosition() {
        const rect = this.titleElement.nativeElement.getBoundingClientRect();
        const screenHeight = window.innerHeight;


        this.isHighlighted = rect.top < screenHeight / 3;
    }
}
